import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components/native';
import {
  WorkoutContainerHeaderTwo,
  WorkoutContainerHeaderThree,
  WorkoutContainerText,
  WorkoutTextHeader
} from '../styles/common-styles.js';
import ActivityButton from './ActivityButton.js';
import { useWindowDimensions } from '../hooks/useWindowDimensions.js';

function ActivityRow({activities, workout, category_name, category_text, navigation, isWorkout}) {
  const { width, height } = useWindowDimensions();
  const verticalLayout = height > width;
  const { userType, userId } = useSelector((state) => state.cbcAuthorization);
  return (
    <ActivityRowParent>
        <WorkoutFreeChoice screenWidth={width}>
            <WorkoutTextHeader>{category_name}</WorkoutTextHeader>
            <WorkoutContainerText>{category_text}</WorkoutContainerText>
            <ActivitiesContainer verticalLayout={verticalLayout}>
              {activities.map((item) => (
                <ActivityButton 
                  key={item.id}
                  id={item.id}
                  name={item.name}
                  shortcode={item.shortcode}
                  thumbnail={item.img_url}
                  text={item.description}
                  current_workout={workout}
                  navigation={navigation}
                  isWorkout={isWorkout}
                  hasScoring={item.has_scoring}
                  userType={userType}
                  userId={userId}
                />
              ))}
            </ActivitiesContainer>
        </WorkoutFreeChoice>
    </ActivityRowParent>
  );
}

export const ActivityRowParent = styled.View`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const WorkoutFreeChoice = styled.View`
  width: 100%;
  left: 0;
  height: auto;
  padding: 30px;
  margin-bottom: 0px;
`;

export const ActivitiesContainer = styled.View`
  flex-direction: ${(props) => (props.verticalLayout ? 'column' : 'row')};
  margin-bottom: -45px;
  margin-top: 15px;
  flex-wrap:wrap;
  flex-direction:row;
  width:100%;
  height:100%;

`;

export default ActivityRow;
